export const ServiceTypeEnum = {
  User: "User",
  Auth: "Auth",
  ExternalMiddleware: "ExternalMiddleware",
  Analyze: "Analyze",
  SportsService: "SportsService",
  WySporst: "WySporst",
}

// Program Type Enum
export const ProgramTypeEnum = {
  LISANS: "Lisans",
  ONLISANS: "Önlisans",
  MASTER: "Master",
  DOKTORA: "Doktora"
}

// Education Language Enum
export const EducationLanguageEnum = {
  TURKCE: "Türkçe",
  INGILIZCE: "İngilizce",
  ALMANCA: "Almanca",
  FRANSIZCA: "Fransızca",
  DIGER: "Diğer"
}

// Degree Enum
export const DegreeEnum = {
  LISANS: "Lisans",
  ONLISANS: "Önlisans",
  YUKSEK_LISANS: "Yüksek Lisans",
  DOKTORA: "Doktora",
  HAZIRLIK: "Hazırlık"
}

// Citizenship Status Enum
export const CitizenshipStatusEnum = {
  BLUE_CARD: "blue_card",
  DUAL_CITIZEN: "dual_citizen",
  FOREIGN_ONLY: "foreign_only",
  TC_CITIZEN_ABROAD: "tc_citizen_abroad",
  RESIDENCE_PERMIT: "residence_permit"
}

// Phone Country Code Enum
export const PhoneCountryCodeEnum = {
  TURKEY: "+90",
  USA: "+1",
  UK: "+44",
  GERMANY: "+49",
  FRANCE: "+33"
}

// Program Type Options (for Select components)
export const ProgramTypeOptions = [
  { value: ProgramTypeEnum.LISANS, label: ProgramTypeEnum.LISANS },
  { value: ProgramTypeEnum.ONLISANS, label: ProgramTypeEnum.ONLISANS },
  { value: ProgramTypeEnum.MASTER, label: ProgramTypeEnum.MASTER },
  { value: ProgramTypeEnum.DOKTORA, label: ProgramTypeEnum.DOKTORA }
]

// Education Language Options (for Select components)
export const EducationLanguageOptions = [
  { value: EducationLanguageEnum.TURKCE, label: EducationLanguageEnum.TURKCE },
  { value: EducationLanguageEnum.INGILIZCE, label: EducationLanguageEnum.INGILIZCE },
  { value: EducationLanguageEnum.ALMANCA, label: EducationLanguageEnum.ALMANCA },
  { value: EducationLanguageEnum.FRANSIZCA, label: EducationLanguageEnum.FRANSIZCA },
  { value: EducationLanguageEnum.DIGER, label: EducationLanguageEnum.DIGER }
]

// Degree Options (for Select components)
export const DegreeOptions = [
  { value: DegreeEnum.LISANS, label: DegreeEnum.LISANS },
  { value: DegreeEnum.ONLISANS, label: DegreeEnum.ONLISANS },
  { value: DegreeEnum.YUKSEK_LISANS, label: DegreeEnum.YUKSEK_LISANS },
  { value: DegreeEnum.DOKTORA, label: DegreeEnum.DOKTORA },
  { value: DegreeEnum.HAZIRLIK, label: DegreeEnum.HAZIRLIK }
]

// Citizenship Status Options (for Radio/Select components)
export const CitizenshipStatusOptions = [
  { value: CitizenshipStatusEnum.BLUE_CARD, label: "Mavi Kartlıyım" },
  { value: CitizenshipStatusEnum.DUAL_CITIZEN, label: "Çifte Uyruklu" },
  { value: CitizenshipStatusEnum.FOREIGN_ONLY, label: "Sadece Yabancı uyruklu" },
  { value: CitizenshipStatusEnum.TC_CITIZEN_ABROAD, label: "Sadece T.C. Vatandaşlığı (Liseyi Yurtdışında okudum)" },
  { value: CitizenshipStatusEnum.RESIDENCE_PERMIT, label: "Türkiye'de Oturma İzni İle Kalıyorum" }
]

// Phone Country Code Options (for Select components)
export const PhoneCountryCodeOptions = [
  { value: PhoneCountryCodeEnum.TURKEY, label: "🇹🇷 +90" },
  { value: PhoneCountryCodeEnum.USA, label: "🇺🇸 +1" },
  { value: PhoneCountryCodeEnum.UK, label: "🇬🇧 +44" },
  { value: PhoneCountryCodeEnum.GERMANY, label: "🇩🇪 +49" },
  { value: PhoneCountryCodeEnum.FRANCE, label: "🇫🇷 +33" }
]

// User Type Enum
export const UserTypeEnum = {
  ADMIN: "admin",
  AGENT: "agent",
  STUDENT: "student",
}

// University Type Enum
export const UniversityTypeEnum = {
  PUBLIC: "public",
  PRIVATE: "private"
}

// Status Enum
export const StatusEnum = {
  ACTIVE: "true",
  INACTIVE: "false"
}

// Filter Options (for Select components with i18n keys)
// University Type Options
export const UniversityTypeOptions = [
  { value: UniversityTypeEnum.PUBLIC, label: 'UNIVERSITIES_TYPE_PUBLIC' },
  { value: UniversityTypeEnum.PRIVATE, label: 'UNIVERSITIES_TYPE_PRIVATE' }
]

// Status Options (Active/Inactive)
export const StatusOptions = [
  { value: StatusEnum.ACTIVE, label: 'UNIVERSITIES_STATUS_ACTIVE' },
  { value: StatusEnum.INACTIVE, label: 'UNIVERSITIES_STATUS_INACTIVE' }
]

// Programs Status Options (for Programs filter)
export const ProgramsStatusOptions = [
  { value: StatusEnum.ACTIVE, label: 'PROGRAMS_TABLE_STATUS_ACTIVE' },
  { value: StatusEnum.INACTIVE, label: 'PROGRAMS_TABLE_STATUS_INACTIVE' }
]

// Common "All" option for filters
export const CommonAllOption = { value: '', label: 'COMMON_ALL' }

// Announcement Type Enum
export const AnnouncementTypeEnum = {
  GENERAL: 'general',
  AGENT: 'agent',
  STUDENT: 'student'
}

// Announcement Target User Enum
export const AnnouncementTargetUserTypeEnum = {
  ALL: 'all',
  ADMIN: 'admin',
  AGENT: 'agent',
  STUDENT: 'student'
}

// Announcement filter options
export const AnnouncementTypeOptions = [
  CommonAllOption,
  { value: AnnouncementTypeEnum.GENERAL, label: 'ANNOUNCEMENTS_TYPE_GENERAL' },
  { value: AnnouncementTypeEnum.AGENT, label: 'ANNOUNCEMENTS_TYPE_AGENT' },
  { value: AnnouncementTypeEnum.STUDENT, label: 'ANNOUNCEMENTS_TYPE_STUDENT' }
]

export const AnnouncementTargetUserTypeOptions = [
  CommonAllOption,
  // { value: AnnouncementTargetUserTypeEnum.ALL, label: 'ANNOUNCEMENTS_TARGET_ALL' },
  { value: AnnouncementTargetUserTypeEnum.ADMIN, label: 'ANNOUNCEMENTS_TARGET_ADMIN' },
  { value: AnnouncementTargetUserTypeEnum.AGENT, label: 'ANNOUNCEMENTS_TARGET_AGENT' },
  { value: AnnouncementTargetUserTypeEnum.STUDENT, label: 'ANNOUNCEMENTS_TARGET_STUDENT' }
]

export const AnnouncementPublishStatusOptions = [
  CommonAllOption,
  { value: 'true', label: 'ANNOUNCEMENTS_FILTERS_STATUS_PUBLISHED' },
  { value: 'false', label: 'ANNOUNCEMENTS_FILTERS_STATUS_DRAFT' }
]

// Application Status Enum
export const ApplicationStatusEnum = {
  DRAFT: 'draft',
  SUBMITTED: 'submitted',
  UNDER_REVIEW: 'under_review',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  WAITLISTED: 'waitlisted',
  CANCELLED: 'cancelled'
}

// Application Period Enum
export const ApplicationPeriodEnum = {
  FALL: 'fall',
  SPRING: 'spring',
  SUMMER: 'summer'
}

// Application Status Options (for Select components with i18n keys)
export const ApplicationStatusOptions = [
  { value: ApplicationStatusEnum.DRAFT, label: 'APPLICATIONS_STATUS_DRAFT' },
  { value: ApplicationStatusEnum.SUBMITTED, label: 'APPLICATIONS_STATUS_SUBMITTED' },
  { value: ApplicationStatusEnum.UNDER_REVIEW, label: 'APPLICATIONS_STATUS_UNDER_REVIEW' },
  { value: ApplicationStatusEnum.ACCEPTED, label: 'APPLICATIONS_STATUS_ACCEPTED' },
  { value: ApplicationStatusEnum.REJECTED, label: 'APPLICATIONS_STATUS_REJECTED' },
  { value: ApplicationStatusEnum.WAITLISTED, label: 'APPLICATIONS_STATUS_WAITLISTED' },
  { value: ApplicationStatusEnum.CANCELLED, label: 'APPLICATIONS_STATUS_CANCELLED' }
]

// Application Period Options (for Select components with i18n keys)
export const ApplicationPeriodOptions = [
  { value: ApplicationPeriodEnum.FALL, label: 'APPLICATIONS_FILTERS_PERIOD_FALL' },
  { value: ApplicationPeriodEnum.SPRING, label: 'APPLICATIONS_FILTERS_PERIOD_SPRING' },
  { value: ApplicationPeriodEnum.SUMMER, label: 'APPLICATIONS_FILTERS_PERIOD_SUMMER' }
]



